import type { LoginRequest, LoginResponse, AuthError } from './auth.types';

const BASE_URL = 'https://pixi.cyberyokai.com/api/v1';
const TOKEN_KEY = 'pixi_access_token';

export class AuthService {
  static async login(data: LoginRequest): Promise<LoginResponse> {
    const res = await fetch(`${BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      const error: AuthError = await res.json().catch(() => ({
        message: 'Login failed',
        statusCode: res.status,
      }));
      throw error;
    }

    const result: LoginResponse = await res.json();
    localStorage.setItem(TOKEN_KEY, result.access_token);
    return result;
  }

  static async register(data: LoginRequest): Promise<LoginResponse> {
    const res = await fetch(`${BASE_URL}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      const error: AuthError = await res.json().catch(() => ({
        message: 'Registration failed',
        statusCode: res.status,
      }));
      throw error;
    }

    // Auto-login after successful registration
    return AuthService.login(data);
  }

  static getStoredToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  static async validateToken(): Promise<boolean> {
    const token = AuthService.getStoredToken();
    if (!token) return false;

    try {
      const res = await fetch(`${BASE_URL}/games`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.ok;
    } catch {
      return false;
    }
  }

  static clearToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }
}
